export const SELECT_PAGES_IF_MORE = Number(
  import.meta.env.VITE_SELECT_PAGES_IF_MORE || '150'
)

export const AI_ATTEMPTS = Number(import.meta.env.VITE_AI_ATTEMPTS || '5')

export const { VITE_AI_HOST } = import.meta.env

export const PUBLIC_API_ENABLED =
  import.meta.env.VITE_PUBLIC_API_ENABLED === 'true'
